var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gpfup__drag-handle",class:{ 'gpfup__drag-handle--disabled': _vm.disabled }})}
var staticRenderFns = []

export { render, staticRenderFns }